<template>
  <div>
    <input-field label="名称" v-model="name" :disabled="!editable"></input-field>
    <input-field label="版本" v-model="version" :disabled="!editable"></input-field>
    <input-field label="网关SN" v-model="serialNumber" :disabled="!editable"></input-field>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  import InputField from '@/components/utils/input-field'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    props: {
      defaults: {
        required: false,
        default () {
          return {}
        },
        type: Object
      },
      event: {
        required: false,
        default: 'func',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    data () {
      return {
        name: '',
        version: '',
        serialNumber: ''
      }
    },
    components: {
      InputField,
      SubmitField
    },
    methods: {
      refresh () {
        this.name = this.defaults.name
        this.version = this.defaults.version
        this.serialNumber = this.defaults.serialNumber
      },
      submit () {
        this.$emitter.emit(this.event, {
          name: this.name,
          version: this.version,
          serialNumber: this.serialNumber
        })

        this.editable = false
      }
    },
    created () {
      this.refresh()
    },
    watch: {
      defaults () {
        this.refresh()
      }
    },
    computed: {
      isValid () {
        return this.name && this.version && this.serialNumber
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/global.vue